import {
  Box,
  Flex,
  Text,
  spaces,
  sizes,
  useThemeColors,
  ColorsV2,
  Button,
  Icon,
} from '@electricjs/arc';

type CollapseBoxProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  isCollapsed: boolean;
  onToggle: () => void;
};

export const CollapseBox = ({
  title,
  subtitle,
  children,
  isCollapsed,
  onToggle,
}: CollapseBoxProps) => {
  const [headerBackgroundColor, borderColor] = useThemeColors([
    ColorsV2.GRAY_LIGHTER,
    ColorsV2.BORDER_DISABLED,
  ]);

  return (
    <Flex
      vertical
      width="100%"
      border={`1px solid ${borderColor}`}
      borderRadius={sizes.size_8}>
      {/* Header */}
      <Flex
        width="100%"
        justifyContent="space-between"
        padding={spaces.space_l}
        backgroundColor={headerBackgroundColor}
        borderRadius={`${sizes.size_8} ${sizes.size_8} ${isCollapsed ? sizes.size_8 : 0} ${isCollapsed ? sizes.size_8 : 0}`}>
        {/* Left-side */}
        <Flex vertical rowGap={spaces.space_3xs} minWidth="0">
          <Text variant="heading-3" fontSize="1.8rem">
            {title}
          </Text>
          {subtitle && <Text variant="body">{subtitle}</Text>}
        </Flex>
        {/* Right-side */}
        <Button
          id="toggle-collapse-button"
          alignSelf="center"
          variant="outline"
          flexShrink="0"
          paddingY={spaces.space_2xs}
          onClick={onToggle}>
          <Icon
            icon={isCollapsed ? 'chevron-down' : 'chevron-up'}
            size="small"
            intent="primary"
          />
        </Button>
      </Flex>

      {/* Content */}
      {!isCollapsed && (
        <Box width="100%" padding={`${spaces.space_m} ${spaces.space_l}`}>
          {children}
        </Box>
      )}
    </Flex>
  );
};
